import { TimelineMax, Expo } from 'gsap';

import hades from '@/scripts/hades';
// import utils from '@/scripts/utils';

export function defaultIn(el, done, delay) {
  const tl = new TimelineMax({
    onComplete: () => {
      hades.ref.play();
      done();
    },
  });

  tl.to(el, 0.75, {
    autoAlpha: 1,
    ease: Expo.easeInOut,
  });

  return tl;
}

export function defaultOut(el, done) {
  const tl = new TimelineMax({
    onComplete: done,
  });

  tl.to(el, 0.75, {
    autoAlpha: 0,
    ease: Expo.easeInOut,
  });

  return tl;
}
